import React, { useState } from "react";
import Sidebar from "../../sidebar/Sidebar";
import HeaderAffida from "../../header/HeaderAffida";

export default function AuthLayout({ children }: { children: React.ReactNode }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="authLayoutRoot">
      <Sidebar
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />
      <div className="authLayoutMain">
        <HeaderAffida onMenuOpen={() => setMobileOpen(true)} />
        <main>{children}</main>
      </div>
    </div>
  );
}
